/// <reference types="vite-plugin-svgr/client" />
import { ReactElement, ReactNode } from 'react';
import { useLocation, useNavigate, Link } from 'react-router';
import styles from './login.page.module.scss';
import { Login } from '@/me/components';
import { UICard, UISpacer, UIText } from '@/ui';
import { RegionSelector, ExistingCompanies } from '@/common/components';
import SafepointLogo from '@/common/assets/images/safepoint-logo-dark.svg?react';
import { Trans } from 'react-i18next';

type LocationState = {
    from?: { pathname?: string; search?: string };
};

export function LoginPage(): ReactElement {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state as LocationState | null;

    let from = '';
    if (state?.from?.pathname) {
        from = state.from.pathname + (state.from.search || '');
    }

    return (
        <div className={styles.page}>
            <div className={styles.loginHalf}>
                <SafepointLogo width={300} />
                <UISpacer multiplier={4} />
                <UICard className={styles.loginCard}>
                    <Login
                        onSuccess={() => {
                            void navigate(from, { replace: true });
                        }}
                    />
                </UICard>
                <UISpacer multiplier={1} />
                <RegionSelector variant="compact" />
                <UISpacer multiplier={2} />

                <UIText variant="basic">
                    <Trans
                        ns="me"
                        i18nKey="shared.account.dont_have_an_account"
                        components={{ a: <SignUpLink /> }}
                    />
                </UIText>
            </div>
            <div className={styles.quoteHalf}>
                <div className={styles.quoteContainer}>
                    <ExistingCompanies />
                </div>
            </div>
        </div>
    );
}

/**
 * The link inside the account prompt. Wrapping it in a component lets the whole
 * sentence be one translated string, so a language can order it as it needs.
 */
function SignUpLink({ children }: { children?: ReactNode }): ReactElement {
    return (
        <Link to={'/signup'} style={{ textDecoration: 'none' }}>
            <UIText variant="basic" type="link" underlineOnHover>
                {children}
            </UIText>
        </Link>
    );
}
